import React from "react";
import HorizontalScroller from "./HorizontalScroller";

export default class HorizontalScrollerWithViewDetection extends React.Component {
  renderAll = ({ scrollLeft, offsetWidth }) => {
    let startIndex = Math.floor(scrollLeft / this.props.averageItemWidth);
    startIndex = Math.max(0, startIndex - this.props.extraItems);
    let endIndex =
      startIndex + Math.ceil(offsetWidth / this.props.averageItemWidth);
    endIndex = Math.min(
      endIndex + this.props.extraItems,
      this.props.itemCount - 1
    );
    const items = [];
    for (let i = 0; i < this.props.itemCount; i++) {
      const inView = i >= startIndex && i <= endIndex;
      items.push(this.props.renderItem({ i, inView }));
    }
    return items;
  };

  render() {
    const {
      averageItemWidth,
      itemCount,
      renderItem,
      ...restProps
    } = this.props;

    return (
      <HorizontalScroller
        render={this.renderAll}
        update={itemCount}
        {...restProps}
      />
    );
  }
}

HorizontalScrollerWithViewDetection.defaultProps = {
  extraItems: 0
};
